"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableHeaderContextProvider: function() {
        return TableHeaderContextProvider;
    },
    useIsInTableHeader: function() {
        return useIsInTableHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const tableHeaderContext = /*#__PURE__*/ _react.createContext(undefined);
const tableHeaderContextDefaultValue = '';
const TableHeaderContextProvider = tableHeaderContext.Provider;
const useIsInTableHeader = ()=>_react.useContext(tableHeaderContext) === tableHeaderContextDefaultValue;
